import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the initial state with a string type
const initialState: string = "light"; // or "dark", depending on your default

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
